import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/api/client";
import { useTranslation } from "react-i18next";

export default function ChangePasswordModal({ onClose }) {
  const { t } = useTranslation();
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setMsg("");
    if (newPw !== confirm) { setErr(t("common.pwMismatch")); return; }
    if (newPw.length < 6) { setErr(t("common.pwMismatch")); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { old_password: oldPw, new_password: newPw });
      setMsg(t("common.pwChanged"));
      setTimeout(() => { onClose(); }, 900);
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="modal-backdrop" data-testid="change-pw-modal" onClick={onClose}>
      <div className="modal-card" onClick={(ev) => ev.stopPropagation()}>
        <div className="modal-title">{t("common.changePassword")}</div>
        <form onSubmit={submit}>
          <div className="field">
            <label className="label">{t("common.currentPassword")}</label>
            <input data-testid="cp-old" className="input" type="password" required value={oldPw} onChange={(e) => setOldPw(e.target.value)} />
          </div>
          <div className="field">
            <label className="label">{t("common.newPassword")}</label>
            <input data-testid="cp-new" className="input" type="password" required minLength={6} value={newPw} onChange={(e) => setNewPw(e.target.value)} />
          </div>
          <div className="field">
            <label className="label">{t("common.confirmPassword")}</label>
            <input data-testid="cp-confirm" className="input" type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          </div>
          {err && <div data-testid="cp-err" style={{ color: "#DC2626", marginBottom: 10 }}>{err}</div>}
          {msg && <div data-testid="cp-msg" style={{ color: "#16A34A", marginBottom: 10 }}>{msg}</div>}
          <div className="row-actions">
            <button type="button" className="btn btn-outline" onClick={onClose}>{t("common.cancel")}</button>
            <button type="submit" className="btn btn-primary" disabled={busy} data-testid="cp-submit">
              {busy ? t("common.loading") : t("common.save")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
